import { render, staticRenderFns } from "./BtnOk.vue?vue&type=template&id=0a7bd5d4&"
import script from "./BtnOk.vue?vue&type=script&lang=js&"
export * from "./BtnOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports